// import React, { useState, useEffect } from 'react';
// import { 
//   Container, 
//   Row, 
//   Col, 
//   Form, 
//   Spinner,
//   Table,
//   Pagination
// } from 'react-bootstrap';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Legend
// } from 'recharts';
// import axios from '../api/axios';
// import PropTypes from 'prop-types';

// const DATE_FILTER_OPTIONS = [
//   { label: 'Today',       value: 'today' },
//   { label: 'Yesterday',   value: 'yesterday' },
//   { label: 'Last 7 Days', value: 'last7days' },
//   { label: 'Last 30 Days',value: 'last30days' },
//   { label: 'This Month',  value: 'thisMonth' },
//   { label: 'Last Month',  value: 'lastMonth' },
// ];

// const ProductsKPI = ({ outlets, loadingOutlets }) => {

//   const token = localStorage.getItem('authToken');

//   const [deactivatedProductsList, setDeactivatedProductsList] = useState([]);
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [totalRecords, setTotalRecords] = useState('');
//   const [totalPages, setTotalPages] = useState('');

//   // State to hold the raw API data
//   const [rawTopSellingProducts, setRawTopSellingProducts] = useState([]);
//   const [rawTopNonSellingProducts, setRawTopNonSellingProducts] = useState([]);
//   const [rawTopLeastSellingProducts, setRawTopLeastSellingProducts] = useState([]);

//   // State for filtered data used in charts
//   const [topSellingProducts, setTopSellingProducts] = useState([]);
//   const [topNonSellingProducts, setTopNonSellingProducts] = useState([]);
//   const [topLeastSellingProducts, setTopLeastSellingProducts] = useState([]);

//   // Filters
//   const [outletFilter, setOutletFilter] = useState('all');
//   const [classTypeFilter, setClassTypeFilter] = useState('all');
//   const [foodTypeFilter, setFoodTypeFilter] = useState('all');
//   const [dateFilter, setDateFilter] = useState('today');  

//   // Loading states
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const [loadingFilter, setLoadingFilter] = useState(false);
//   const [deactivatedLoading, setDeactivatedLoading] = useState(false);

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//     // getDeactivatedProducts(newPage, limit);
//   };

//   const handleRowsPerPageChange = (e) => {
//     const newLimit = parseInt(e.target.value, 10);
//     setLimit(newLimit);
//     setPage(1); // reset to first page
//     // getDeactivatedProducts(1, newLimit);
//   };

//   // Fetch Deactivated Products Api
//   const getDeactivatedProducts = async(page , limit) => {
//     setDeactivatedLoading(true);
//     try {
//       const headers = {
//         Authorization: `Bearer ${token}`
//       }
//       const response = await axios.get(`dashboard/getDeactivatedProducts?page=${page}&limit=${limit}`, { headers });
//       console.log("Response :", response?.data?.data);
//       setDeactivatedProductsList(response?.data?.data);
//       setTotalPages(response?.data?.pagination?.totalPages);
//       setTotalRecords(response?.data?.pagination?.total);
//     } catch (error) {
//       console.log("Error in Deactivated Products :", error);
//     } finally {
//       setDeactivatedLoading(false);
//     }
//   }

//   // Fetch API data from the endpoint with filters
//   const fetchProductsKIPData = async (outlet, cType, fType, dateF) => {
//     try {
//       setLoadingProducts(true);
//       setLoadingFilter(true);

//       let url = `dashboard/getProductsStatThroughSummary`
//       const params = new URLSearchParams();

//       if (outlet !== 'all') {
//         params.append('outletId', outlet);
//       }
//       if (cType !== 'all') {
//         params.append('classType', cType);
//       }
//       if (fType !== 'all') {
//         params.append('foodType', fType);
//       }
//       if (dateF) {
//         params.append('dateFilter', dateF);
//       }

//       if (params.toString()) {
//         url += `?${params.toString()}`;
//       }

//       const response = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       console.log("Response of Product KPI's :", response);

//       setRawTopSellingProducts(response?.data?.data?.data?.topTenSellingProducts || []);
//       setRawTopNonSellingProducts(response?.data?.data?.data?.topTenNonSellingProducts || []);
//       setRawTopLeastSellingProducts(response?.data?.data?.data?.topTenLeastSellingProducts || []);
//     } catch (error) {
//       console.error('Error fetching products data:', error);
//     } finally {
//       setLoadingProducts(false);
//       setLoadingFilter(false);
//     }
//   };

//   const handleOutletChange = (e) => {
//     const outId = e.target.value;
//     setOutletFilter(outId);
//     fetchProductsKIPData(outId, classTypeFilter, foodTypeFilter, dateFilter);
//   };

//   const handleClassTypeChange = (e) => {
//     const cType = e.target.value;
//     setClassTypeFilter(cType);
//     fetchProductsKIPData(outletFilter, cType, foodTypeFilter, dateFilter);
//   };

//   const handleFoodTypeChange = (e) => {
//     const fType = e.target.value;
//     setFoodTypeFilter(fType);
//     fetchProductsKIPData(outletFilter, classTypeFilter, fType, dateFilter);
//   };

//   const handleDateFilterChange = (e) => {
//     const dateF = e.target.value;
//     setDateFilter(dateF);
//     fetchProductsKIPData(outletFilter, classTypeFilter, foodTypeFilter, dateF);
//   };

//   // Fetch the API data on initial component mount
//   useEffect(() => {
//     fetchProductsKIPData(outletFilter, classTypeFilter, foodTypeFilter, dateFilter);
//     // getDeactivatedProducts(page, limit);
//   }, []);

//   // Apply client-side filtering if needed
//   useEffect(() => {
//     setTopSellingProducts(rawTopSellingProducts);
//     setTopNonSellingProducts(rawTopNonSellingProducts);
//     setTopLeastSellingProducts(rawTopLeastSellingProducts);
//   }, [rawTopSellingProducts, rawTopNonSellingProducts, rawTopLeastSellingProducts]);

//   const resetFilters = () => {
//     setOutletFilter('all');
//     setClassTypeFilter('all');
//     setFoodTypeFilter('all');
//     setDateFilter('today');
//     fetchProductsKIPData('all', 'all', 'all', 'today');
//   };

//   return (
//     <Container fluid className="py-4 shadow-sm" style={{ backgroundColor: 'white' }}>
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-1">
//         <h4 className='fw-bold mb-0'>PRODUCT ANALYSIS</h4>
//         <div className="d-flex align-items-center bg-light p-1 ps-2 rounded">
//           <i className="bi bi-calendar-event me-2 text-primary" />
//           <Form.Select
//             value={dateFilter}
//             onChange={handleDateFilterChange}
//             style={{ width: '145px' }}
//             className="border-0 bg-light"
//           >
//             {DATE_FILTER_OPTIONS.map((opt) => (
//               <option key={opt.value} value={opt.value}>{opt.label}</option>
//             ))}
//           </Form.Select>
//         </div>
//       </div>
//       <hr />

//       {/* Filters */}
//       <Row className="mb-4 g-3">
//         <Col md={3}>
//           <Form.Group>
//             <Form.Label className='fw-semibold text-muted'>Outlet</Form.Label>
//               <Form.Select
//                 value={outletFilter}
//                 onChange={handleOutletChange}
//                 disabled={loadingFilter || loadingOutlets}
//               >
//                 <option value="all">All Outlets</option>
//                 {outlets?.map((outlet) => (
//                   <option key={outlet._id} value={outlet._id}>
//                     {outlet.name}
//                   </option>
//                 ))}
//               </Form.Select>
//           </Form.Group>
//         </Col>

//         <Col md={3}>
//           <Form.Group>
//             <Form.Label className='fw-semibold text-muted'>Class Type</Form.Label>
//             <Form.Select
//               value={classTypeFilter}
//               onChange={handleClassTypeChange}
//               disabled={loadingFilter}
//             >
//               <option value="all">All</option>
//               <option value="FOOD">Food</option>
//               <option value="BEVERAGE">Beverage</option>
//             </Form.Select>
//           </Form.Group>
//         </Col>

//         <Col md={3} >
//           <Form.Group>
//             <Form.Label className='fw-semibold text-muted'>Food Type</Form.Label>
//             <Form.Select
//               value={foodTypeFilter}
//               onChange={handleFoodTypeChange}
//               disabled={loadingFilter}
//             >
//               <option value="all">All</option>
//               <option value="VEG">Veg</option>
//               <option value="NON-VEG">Non-Veg</option>
//             </Form.Select>
//           </Form.Group>
//         </Col>

//         <Col md={3} className="d-flex align-items-end">
//           <button 
//             className="btn btn-outline-secondary w-100"
//             onClick={resetFilters}
//             disabled={loadingFilter}
//           >
//             Reset Filters
//           </button>
//         </Col>
//       </Row>

//       {loadingProducts ? (
//         <Row className="justify-content-center my-5">
//           <Col md="auto">
//             <div className="d-flex flex-column align-items-center">
//               <Spinner animation="border" variant="primary" />
//               <span className="mt-2">Loading product data...</span>
//             </div>
//           </Col>
//         </Row>
//       ) : (
//         <>
//           {/* Top Selling and Least Selling Products Charts - Side by Side */}
//           <Row>
//             <Col md={6}>
//               <h5>Top 10 Selling Products</h5>

//               {topSellingProducts?.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={400}>
//                   <BarChart 
//                     data={topSellingProducts}
//                     margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
//                   >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis 
//                       dataKey="productName"
//                       interval={0}
//                       tick={{
//                         fontSize: 10,
//                         angle: -45,
//                         textAnchor: 'end',
//                         fill: '#555'
//                       }}
//                       height={80}
//                     />
//                     <YAxis />
//                     <Tooltip />
//                     <Legend />
//                     <Bar
//                       dataKey="totalSaleCount"
//                       fill="#8884d8"
//                       className='fw-semibold'
//                       name="Ordered Count"
//                       barSize={20}
//                     />
//                   </BarChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <div className="d-flex justify-content-center align-items-center bg-light rounded" style={{ height: '300px' }}>
//                   <div className="text-muted">No data available</div>
//                 </div>
//               )}
//             </Col>

//             <Col md={6}>
//               <h5>Top 10 Least Selling Products</h5>
//               {topLeastSellingProducts?.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={400}>
//                   <BarChart 
//                     data={topLeastSellingProducts}
//                     margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
//                   >
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis 
//                       dataKey="productName"
//                       interval={0}
//                       tick={{
//                         fontSize: 10,
//                         angle: -45,
//                         textAnchor: 'end',
//                         fill: '#555'
//                       }}
//                       height={80}
//                     />
//                     <YAxis />
//                     <Tooltip />
//                     <Legend />
//                     <Bar
//                       dataKey="totalSaleCount"
//                       fill="#ffc658"
//                       className='fw-semibold'
//                       name="Ordered Count"
//                       barSize={20}
//                     />
//                   </BarChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <div className="d-flex justify-content-center align-items-center bg-light rounded" style={{ height: '300px' }}>
//                   <div className="text-muted">No data available</div>
//                 </div>
//               )}
//             </Col>
//           </Row>

//           {/* Top Non-Selling Products Table - Below */}
//           {/* <Row className="mt-4">
//             <Col md={12}>
//               <h5>Top 10 Non-Selling Products</h5>
//               {topNonSellingProducts?.length > 0 ? (
//                 <div className="table-responsive">
//                   <Table striped bordered hover className="mt-1">
//                     <thead className="table-dark">
//                       <tr>
//                         <th>#</th>
//                         <th>Product Name</th>
//                         <th>Category</th>
//                         <th>Class Type</th>
//                         <th>Food Type</th>
//                         <th>Ordered Count</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {topNonSellingProducts?.map((product, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>
//                             <span className='fw-semibold text-secondary'>{product?.name}</span>
//                           </td>
//                           <td style={{ color: 'purple' }}>{product?.category?.name}</td>
//                           <td>{product?.classType || '-'}</td>
//                           <td>{product?.foodType || '-'}</td>
//                           <td>{product?.orderedCount || 0}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//               ) : (
//                 <div className="d-flex justify-content-center align-items-center bg-light rounded" style={{ height: '100px' }}>
//                   <div className="text-muted">No non-selling products data available</div>
//                 </div>
//               )}
//             </Col>
//           </Row>

//           <Row className="mt-2">
//             <Col md={12}>
//               <h5>Deactivated Products</h5>
//               {deactivatedProductsList?.length > 0 ? (
//                 <div className="table-responsive">

//                   <Table striped bordered hover className="mt-1">
//                     <thead className="table-danger">
//                       <tr>
//                         <th>#</th>
//                         <th>Deactivated On</th>
//                         <th>Product Name</th>
//                         <th>Category</th>
//                         <th>Class Type</th>
//                         <th>Food Type</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {deactivatedProductsList?.map((product, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{new Date(product?.updatedAt).toLocaleString('en-GB', {
//                               day: '2-digit',
//                               month: 'short',
//                               year: 'numeric',
//                               hour: '2-digit',
//                               minute: '2-digit',
//                               hour12: true,
//                             })}
//                           </td>

//                           <td>
//                             <span className='fw-semibold text-secondary'>{product?.name}</span>
//                           </td>
//                           <td style={{ color: 'purple' }}>{product?.category?.name}</td>
//                           <td>{product?.classType || '-'}</td>
//                           <td>{product?.foodType || '-'}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>

//                   <div className="d-flex justify-content-between align-items-center mt-3">
//                     <div className="d-flex align-items-center">
//                       <span className="me-2 text-muted">Show</span>
//                       <Form.Select style={{ width: 'auto' }} value={limit} onChange={handleRowsPerPageChange}>
//                         <option value={10}>10</option>
//                         <option value={25}>25</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                       </Form.Select>
//                       <span className="ms-2 text-muted">entries</span>
//                     </div>

//                     <div className="d-flex align-items-center">
//                       <Pagination className="mb-0">
//                         <Pagination.Prev disabled={page === 1} onClick={() => handlePageChange(page - 1)} />
//                         {Array.from({ length: totalPages }, (_, i) => (
//                           <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => handlePageChange(i + 1)}>
//                             {i + 1}
//                           </Pagination.Item>
//                         ))}
//                         <Pagination.Next disabled={page === totalPages} onClick={() => handlePageChange(page + 1)} />
//                       </Pagination>
//                     </div>
//                   </div>

//                 </div>
//               ) : (
//                 <div className="d-flex justify-content-center align-items-center bg-light rounded" style={{ height: '100px' }}>
//                   <div className="text-muted">No deactivated products data available</div>
//                 </div>
//               )}
//             </Col>
//           </Row> */}
//         </>
//       )}
//     </Container>
//   );
// };

// ProductsKPI.propTypes = {
//   outlets: PropTypes.arrayOf(PropTypes.shape({
//     _id: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired,
//     status: PropTypes.string
//   })),
//   loadingOutlets: PropTypes.bool
// };

// ProductsKPI.defaultProps = {
//   outlets: [],
//   loadingOutlets: false
// };

// export default ProductsKPI;


import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Spinner,
  Button,
  Card,
  Badge,
} from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";
import axios from "../api/axios";
import PropTypes from "prop-types";

const DATE_FILTER_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 Days", value: "last7days" },
  { label: "Last 30 Days", value: "last30days" },
  { label: "This Month", value: "thisMonth" },
  { label: "Last Month", value: "lastMonth" },
];

const ProductsKPI = ({ outlets, loadingOutlets }) => {
  const token = localStorage.getItem("authToken");

  const [rawTopSellingProducts, setRawTopSellingProducts] = useState([]);
  const [rawTopNonSellingProducts, setRawTopNonSellingProducts] = useState([]);
  const [rawTopLeastSellingProducts, setRawTopLeastSellingProducts] = useState([]);

  const [outletFilter, setOutletFilter] = useState("all");
  const [classTypeFilter, setClassTypeFilter] = useState("all");
  const [foodTypeFilter, setFoodTypeFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState("today");

  const [activeTab, setActiveTab] = useState("top");
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [loadingFilter, setLoadingFilter] = useState(false);

  const safeNum = (value) => Number(value || 0);

  const getProductName = (item) =>
    item?.productName || item?.name || "Unnamed Product";

  const getOrderCount = (item) =>
    safeNum(item?.totalSaleCount ?? item?.orderedCount);

  const fetchProductsKIPData = async (outlet, cType, fType, dateF) => {
    try {
      setLoadingProducts(true);
      setLoadingFilter(true);

      let url = "dashboard/getProductsStatThroughSummary";
      const params = new URLSearchParams();

      if (outlet !== "all") params.append("outletId", outlet);
      if (cType !== "all") params.append("classType", cType);
      if (fType !== "all") params.append("foodType", fType);
      if (dateF) params.append("dateFilter", dateF);

      if (params.toString()) url += `?${params.toString()}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response?.data?.data?.data || {};

      setRawTopSellingProducts(data?.topTenSellingProducts || []);
      setRawTopNonSellingProducts(data?.topTenNonSellingProducts || []);
      setRawTopLeastSellingProducts(data?.topTenLeastSellingProducts || []);
    } catch (error) {
      console.error("Error fetching products data:", error);
    } finally {
      setLoadingProducts(false);
      setLoadingFilter(false);
    }
  };

  useEffect(() => {
    fetchProductsKIPData(outletFilter, classTypeFilter, foodTypeFilter, dateFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetFilters = () => {
    setOutletFilter("all");
    setClassTypeFilter("all");
    setFoodTypeFilter("all");
    setDateFilter("today");
    fetchProductsKIPData("all", "all", "all", "today");
  };

  const handleFilterChange = (type, value) => {
    let outlet = outletFilter;
    let cType = classTypeFilter;
    let fType = foodTypeFilter;
    let dateF = dateFilter;

    if (type === "outlet") {
      outlet = value;
      setOutletFilter(value);
    }

    if (type === "classType") {
      cType = value;
      setClassTypeFilter(value);
    }

    if (type === "foodType") {
      fType = value;
      setFoodTypeFilter(value);
    }

    if (type === "date") {
      dateF = value;
      setDateFilter(value);
    }

    fetchProductsKIPData(outlet, cType, fType, dateF);
  };

  const topSellingOrders = rawTopSellingProducts.reduce(
    (sum, item) => sum + getOrderCount(item),
    0
  );

  const leastSellingOrders = rawTopLeastSellingProducts.reduce(
    (sum, item) => sum + getOrderCount(item),
    0
  );

  const topProduct = getProductName(rawTopSellingProducts?.[0]);
  const leastProduct = getProductName(rawTopLeastSellingProducts?.[0]);

  const currentChartData = useMemo(() => {
    const source =
      activeTab === "least"
        ? rawTopLeastSellingProducts
        : activeTab === "non"
          ? rawTopNonSellingProducts
          : rawTopSellingProducts;

    return source.map((item) => ({
      ...item,
      productLabel: getProductName(item),
      orderCount: activeTab === "non" ? 0 : getOrderCount(item),
    }));
  }, [
    activeTab,
    rawTopSellingProducts,
    rawTopLeastSellingProducts,
    rawTopNonSellingProducts,
  ]);

  const currentChartTitle = {
    top: "Top Selling Products",
    least: "Slow Moving Products",
    non: "Products With No Sales",
  }[activeTab];

  const currentChartSubTitle = {
    top: "Products with the highest order count.",
    least: "Products with low order count.",
    non: "Products with zero orders in the selected period.",
  }[activeTab];

  const maxSaleCount = Math.max(
    ...currentChartData.map((item) => Number(item.orderCount || 0)),
    1
  );

  return (
    <Container fluid className="reelo-product-kpi py-4">
      <style>
        {`
          .reelo-product-kpi {
            background: #ffffff;
            font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          }

          .reelo-page-title {
            font-size: 25px;
            font-weight: 800;
            color: #101c1d;
            margin-bottom: 3px;
          }

          .reelo-page-subtitle {
            color: #6f7f80;
            font-size: 14px;
            margin-bottom: 0;
          }

          .reelo-select {
            border: 1px solid #dce7e8;
            border-radius: 12px;
            min-height: 42px;
            box-shadow: none !important;
            font-size: 14px;
            font-weight: 600;
          }

          .reelo-select:focus {
            border-color: #00a6a6;
          }

          .reelo-summary-card {
            border: 1px solid #dce7e8;
            border-radius: 18px;
            box-shadow: none;
            overflow: hidden;
            background: #ffffff;
          }

          .reelo-summary-card .card-body {
            padding: 18px;
          }

          .reelo-kpi-box {
            border-radius: 16px;
            padding: 16px;
            height: 100%;
            border: 1px solid rgba(16, 28, 29, 0.05);
          }

          .reelo-kpi-label {
            font-size: 13px;
            font-weight: 800;
            margin-bottom: 6px;
          }

          .reelo-kpi-value {
            font-size: 28px;
            line-height: 1;
            font-weight: 850;
            color: #101c1d;
            margin-bottom: 5px;
          }

          .reelo-kpi-helper {
            font-size: 12.5px;
            font-weight: 600;
            color: #6f7f80;
            margin-bottom: 0;
          }

          .reelo-insight-box {
            border-radius: 16px;
            padding: 16px;
            height: 100%;
            border: 1px solid #e5eeee;
            background-color: #f4f1ff;
          }

          .reelo-insight-label {
            font-size: 12px;
            font-weight: 800;
            color: #6737ff;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 8px;
          }

          .reelo-insight-row {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            font-size: 13px;
            margin-bottom: 6px;
          }

          .reelo-insight-row span:first-child {
            color: #6f7f80;
            font-weight: 600;
          }

          .reelo-insight-row span:last-child {
            color: #101c1d;
            font-weight: 800;
            text-align: right;
          }

          .reelo-chart-card {
            border: 1px solid #dce7e8;
            border-radius: 18px;
            box-shadow: none;
            overflow: hidden;
          }

          .reelo-chart-tabs {
            display: flex;
            gap: 28px;
            border-bottom: 1px solid #e6eeee;
            margin-bottom: 20px;
          }

          .reelo-chart-tab {
            border: 0;
            background: transparent;
            padding: 0 0 12px;
            font-weight: 800;
            color: #6f7f80;
            position: relative;
          }

          .reelo-chart-tab.active {
            color: #101c1d;
          }

          .reelo-chart-tab.active::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -1px;
            width: 100%;
            height: 4px;
            background: #101c1d;
            border-radius: 5px 5px 0 0;
          }

          .reelo-empty-state {
            height: 350px;
            border-radius: 16px;
            background: #f7fbfb;
            color: #7b8b8c;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
          }

          .reelo-loader {
            height: 420px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .reelo-non-list {
            height: 430px;
            overflow-y: auto;
            padding-right: 6px;
          }

          .reelo-non-item {
            border: 1px solid #e7eeee;
            background: #fbfefe;
            border-radius: 14px;
            padding: 14px 16px;
            margin-bottom: 12px;
          }
        `}
      </style>

      <Card className="reelo-summary-card mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
            <div>
              <h3 className="reelo-page-title">Product Analysis</h3>
              <p className="reelo-page-subtitle">
                Track top sellers, slow movers and products with no sales.
              </p>
            </div>

            <div style={{ minWidth: 170 }}>
              <Form.Select
                value={dateFilter}
                onChange={(e) => handleFilterChange("date", e.target.value)}
                className="reelo-select"
                disabled={loadingFilter}
              >
                {DATE_FILTER_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <Row className="g-3">
            <Col xl={4} md={6}>
              <div className="reelo-kpi-box" style={{ background: "#fff4eb" }}>
                <div className="reelo-kpi-label" style={{ color: "#f05a28" }}>
                  Top Sellers
                </div>
                <p className="reelo-kpi-value">{topSellingOrders}</p>
                <p className="reelo-kpi-helper">
                  total orders from these products
                </p>
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div className="reelo-kpi-box" style={{ background: "#eef8ff" }}>
                <div className="reelo-kpi-label" style={{ color: "#1877f2" }}>
                  Slow Movers
                </div>
                <p className="reelo-kpi-value">{leastSellingOrders}</p>
                <p className="reelo-kpi-helper">
                  total orders from these products
                </p>
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div className="reelo-insight-box">
                <div className="reelo-insight-label">Quick insight</div>

                <div className="reelo-insight-row">
                  <span>Top product</span>
                  <span>{topProduct}</span>
                </div>

                <div className="reelo-insight-row mb-0">
                  <span>Slowest product</span>
                  <span>{leastProduct}</span>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="reelo-chart-card mb-4">
        <Card.Body className="p-4">
          <Row className="g-3 mb-4">
            <Col lg={3} md={6}>
              <Form.Label className="fw-semibold text-muted">Outlet</Form.Label>
              <Form.Select
                value={outletFilter}
                onChange={(e) => handleFilterChange("outlet", e.target.value)}
                disabled={loadingFilter || loadingOutlets}
                className="reelo-select"
              >
                <option value="all">All Stores</option>
                {outlets?.map((outlet) => (
                  <option key={outlet._id} value={outlet._id}>
                    {outlet.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col lg={3} md={6}>
              <Form.Label className="fw-semibold text-muted">Class Type</Form.Label>
              <Form.Select
                value={classTypeFilter}
                onChange={(e) => handleFilterChange("classType", e.target.value)}
                disabled={loadingFilter}
                className="reelo-select"
              >
                <option value="all">All</option>
                <option value="FOOD">Food</option>
                <option value="BEVERAGE">Beverage</option>
              </Form.Select>
            </Col>

            <Col lg={3} md={6}>
              <Form.Label className="fw-semibold text-muted">Food Type</Form.Label>
              <Form.Select
                value={foodTypeFilter}
                onChange={(e) => handleFilterChange("foodType", e.target.value)}
                disabled={loadingFilter}
                className="reelo-select"
              >
                <option value="all">All</option>
                <option value="VEG">Veg</option>
                <option value="NON-VEG">Non-Veg</option>
              </Form.Select>
            </Col>

            <Col lg={3} md={6} className="d-flex align-items-end">
              <Button
                variant="outline-dark"
                className="w-100 rounded-3 fw-semibold"
                style={{ minHeight: 42 }}
                onClick={resetFilters}
                disabled={loadingFilter}
              >
                Reset Filters
              </Button>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
            <div>
              <h5 className="fw-bold mb-1">{currentChartTitle}</h5>
              <p className="text-muted mb-0">{currentChartSubTitle}</p>
            </div>

            <div className="reelo-chart-tabs">
              <button
                className={`reelo-chart-tab ${activeTab === "top" ? "active" : ""}`}
                onClick={() => setActiveTab("top")}
              >
                Top Sales
              </button>

              <button
                className={`reelo-chart-tab ${activeTab === "least" ? "active" : ""}`}
                onClick={() => setActiveTab("least")}
              >
                Slow Movers
              </button>

              <button
                className={`reelo-chart-tab ${activeTab === "non" ? "active" : ""}`}
                onClick={() => setActiveTab("non")}
              >
                No Sales
              </button>
            </div>
          </div>

          {loadingProducts ? (
            <div className="reelo-loader">
              <div className="text-center">
                <Spinner animation="border" variant="info" />
                <div className="mt-3 fw-semibold text-muted">
                  Loading product data...
                </div>
              </div>
            </div>
          ) : currentChartData?.length > 0 ? (
            activeTab === "non" ? (
              <div className="reelo-non-list">
                {currentChartData.map((product, index) => (
                  <div
                    key={index}
                    className="reelo-non-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div className="fw-bold" style={{ color: "#101c1d" }}>
                        {index + 1}. {product.productLabel}
                      </div>
                      <div className="text-muted small fw-semibold">
                        {product?.category?.name || "No Category"} ·{" "}
                        {product?.classType || "-"} · {product?.foodType || "-"}
                      </div>
                    </div>

                    <Badge bg="light" text="danger" className="px-3 py-2 rounded-pill">
                      0 Orders
                    </Badge>
                  </div>
                ))}
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={430}>
                <BarChart
                  data={currentChartData}
                  margin={{ top: 25, right: 20, left: 0, bottom: 80 }}
                >
                  <CartesianGrid vertical={false} strokeDasharray="3 3" />
                  <XAxis
                    dataKey="productLabel"
                    interval={0}
                    height={85}
                    tick={{
                      fontSize: 11,
                      angle: -35,
                      textAnchor: "end",
                      fill: "#6f7f80",
                    }}
                  />
                  <YAxis allowDecimals={false} />
                  <Tooltip
                    cursor={{ fill: "#f4fbfb" }}
                    contentStyle={{
                      borderRadius: 12,
                      border: "1px solid #dce7e8",
                    }}
                  />
                  <Bar
                    dataKey="orderCount"
                    name="Ordered Count"
                    radius={[8, 8, 0, 0]}
                    barSize={34}
                  >
                    {currentChartData.map((entry, index) => {
                      const value = Number(entry.orderCount || 0);
                      const opacity = Math.max(value / maxSaleCount, 0.25);

                      return (
                        <Cell
                          key={`cell-${index}`}
                          fill={
                            activeTab === "top"
                              ? `rgba(24, 119, 242, ${opacity})`
                              : `rgba(255, 178, 54, ${opacity})`
                          }
                        />
                      );
                    })}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            )
          ) : (
            <div className="reelo-empty-state">No data available</div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

ProductsKPI.propTypes = {
  outlets: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string,
    })
  ),
  loadingOutlets: PropTypes.bool,
};

ProductsKPI.defaultProps = {
  outlets: [],
  loadingOutlets: false,
};

export default ProductsKPI;